const STORE_SUFFIXES = [
	'Mammafiore Cataluña',
	'Mammafiore Cataluya',
	'Mammafiore Catalonia',
	'Mammafiore Mad',
	'Mammafiore Madrid',
	'Mammafiore España',
	'Mammafiore Spain',
	'Mammafiore United Kingdom',
	'Mammafiore Great Britain',
	'Mammafiore Inglaterra',
	'Mammafiore Canarias',
	'Mammafiore UK',
	'Mammafiore DE',
	'Mammafiore Germany',
	'Mammafiore Deutschland',
	'Mammafiore PT',
	'Mammafiore Portugal',
	'Mammafiore FR',
	'Mammafiore Francia',
	'Mammafiore France',
	'Mammafiore',
]

const escapedSuffixes = STORE_SUFFIXES.map(s => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
const PIPE_STORE_REGEX = new RegExp(`\\s*\\|\\s*(${escapedSuffixes.join('|')})\\s*$`)

export const stripPipeStore = (str: string): string => str.replace(PIPE_STORE_REGEX, '').trimEnd()
